<template>
    <div :class="module.title" class="btn">

        <div v-if="separator" class="separator"></div>

        <button v-else
                :class="['vw-btn-' + module.title,
                        {
                            active: opened,
                        }]"
                class="iconed no-border btn"
                @click="onBtnClick">
            <component :is="icon" />
        </button>
        <TooltipOld v-if="!separator" :disabled="opened" bind-to=".btn" class="tooltip hint" trigger-on="hover">
            {{ title }}
        </TooltipOld>

        <div v-if="opened" ref="dashboard" class="dashboard">
            <component :is="module"
                       v-if="module.render"
                       ref="moduleDashboard"
                       :options="options"
                       :uid="uid"
                       @close="opened = false"
                       @exec="exec" />

        </div>
    </div>
</template>
<script>
import bus from './bus.js';
import IconBold from './icons/bold.svg?component';
import IconCenter from './icons/center.svg?component';
import IconClear from './icons/clear.svg?component';
import IconCode from './icons/code.svg?component';
import IconHeading from './icons/heading.svg?component';
import IconImage from './icons/image.svg?component';
import IconItalic from './icons/italic.svg?component';
import IconLeft from './icons/left.svg?component';
import IconLink from './icons/link.svg?component';
import IconOl from './icons/ol.svg?component';
import IconRight from './icons/right.svg?component';
import IconTable from './icons/table.svg?component';
import IconUl from './icons/ul.svg?component';
import IconUnderline from './icons/underline.svg?component';


export default {
    props: {
        module: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    components: {
        IconBold,
        IconCenter,
        IconClear,
        IconCode,
        IconHeading,
        IconImage,
        IconItalic,
        IconLeft,
        IconLink,
        IconOl,
        IconRight,
        IconTable,
        IconUl,
        IconUnderline,
    },
    computed: {
        uid() {
            return this.$parent._uid;
        },
        icon() {
            return 'Icon' + this.module.icon;
        },
        separator() {
            return this.module.title === 'separator';
        },
    },
    data() {
        return {
            opened: false,
        };
    },
    methods: {
        exec() {
            this.$parent.exec.apply(null, arguments);
            this.opened = false;
        },
        onBtnClick($event) {
            this.$parent.ensureCursorInContent();

            if (this.module.action) {
                this.exec.apply(null, this.module.action);
                return;
            }

            if (!this.module.render)
                return;

            this.opened = !this.opened;
            if (this.opened)
                this.$emit('closeOtherDashboards', this.module.title);

        },
    },
};
</script>
<style lang="scss" scoped>
.btn {
    height: 32px;

    .separator {
        margin: 6px 4px;
        border-left: 1px solid rgba(0, 0, 0, .1);
        height: 20px;
        padding: 0;
        box-sizing: border-box;
    }

    &.active {
        color: var(--theme-accent-color);
    }
}

button {
    width: 32px;
    height: 32px;
    overflow: hidden;
    padding: 8px !important;
}
</style>
